import React from 'react'
import nrt_lock from '../../assets/images/nrt_lock.gif'
import nrt_bet_icon from '../../assets/images/nrt_bet_icon.gif'
import top_bar_icon from '../../assets/images/top_bar_icon.png'
import { useNavigate } from 'react-router-dom';

const CustomerTableList = ({ inquiries }) => {
    const navigate = useNavigate();

    const handleRowClick = (id) => {
        navigate(`/customer/single-customer/${id}`);
    };
    return (
        <>
            <table width="100%" border="0" cellpadding="0" cellspacing="0" className=" p-2.5 block lg:table text-xs text-white font-sans-serif lg:font-Serif lg:p-0 border border-slate lg:border-none bg-charcoal lg:bg-transparent">
                <tbody>
                    {inquiries.map((inquiry, index) => (
                        <tr key={inquiry.id} className="row" onClick={() => handleRowClick(inquiry.id)}>
                            <td width="30" align="center" className=" p-[5px] lg:p-0 h-[35px] border-b border-b-slate">
                                <div className="inline-block align-middle lg:hidden me-1">
                                    <input id={`option${index}`} type="radio" name="point_type" value="M" className="peer hidden" />
                                    <label htmlFor={`option${index}`} className="relative block w-5 h-5 cursor-pointer rounded-md mobile-radio-bg bg-[length:200px_200px] bg-[176px_22px] peer-checked:bg-[-22px_0]" />
                                </div>
                                <input type="checkbox" name="seq" value={inquiry.id} className='align-middle hidden lg:inline-block' />
                            </td>
                            <td width="70" height="30" align="center" className="hidden lg:table-cell h-[35px] border-b border-b-slate">{index + 1}</td>
                            <td className="text-silver lg:text-white p-[5px] lg:p-0 lg:h-[35px] border-b border-b-slate w-full lg:w-auto">
                                <div className="hidden lg:block">
                                    <a href="#">[{inquiry.status === 'PENDING' ? '답변대기' : '답변완료'}] {inquiry.title} </a>
                                    {/* <span className="text-crimson">(1)</span> */}
                                    {inquiry.has_reply && <span className="text-crimson">(1)</span>}
                                    &nbsp;
                                    <img src={nrt_lock} width="9" height="11" className='inline-block' />
                                    &nbsp;
                                    <img src={nrt_bet_icon} className="hidden" align="absmiddle" />&nbsp;&nbsp;
                                </div>
                                <div className="lg:hidden text-white">
                                    <a href="#">
                                        <div className="flex">
                                            [{inquiry.status === 'PENDING' ? '답변대기' : '답변완료'}] {inquiry.title}
                                            <span className=''>
                                                {inquiry.has_reply && (
                                                    <>
                                                        <small className="text-[#FF4F51]">&nbsp;(1)</small>
                                                        &nbsp;
                                                    </>
                                                )}
                                                <img src={nrt_lock} width="9" height="11" className='inline-block align-middle' />
                                                &nbsp;
                                                <i className="fa fa-server bettinfo text-[#009bec] align-middle" seq=""></i>
                                                &nbsp;&nbsp;
                                            </span>
                                        </div>
                                    </a>
                                    <p className='text-silver'>
                                        <small>
                                            <img src={top_bar_icon} align="absmiddle" className='w-[15px] inline-block align-middle' />  panhok
                                        </small>
                                        {/* <small>2025/05/19</small> */}
                                        {/* <small>조회 3</small> */}
                                        <small>{inquiry.created_at.slice(0, 10)}</small>
                                        <small>조회 3</small> {/* Replace with actual views if available */}
                                    </p>
                                </div>
                            </td>
                            <td width="126" className="hidden lg:table-cell h-[35px] border-b border-b-slate">
                                <img src={top_bar_icon} align="absmiddle" className="w-6 inline-block" /> {inquiry.user.nickname}</td>
                            <td width="110" align="center" className="hidden lg:table-cell h-[35px] border-b border-b-slate">{inquiry.created_at.slice(0, 10)}</td>
                            <td width="70" align="center" className="hidden lg:table-cell h-[35px] border-b border-b-slate">{index + 1}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </>
    )
}

export default CustomerTableList